import React from 'react';
import { useIntl } from 'umi';

import { Checkbox, Switch } from 'tea-component';

import DatalabGrid from '@/pages/datalab/components/DatalabGrid';
import LabelText from '@/pages/datalab/components/LabelText';
import SwitchCollapse from '@/pages/datalab/components/SwitchCollapse';
import { getLocalText } from '@/pages/datalab/utils/utils';
import TipContext from '@home/components/TipContext';
import { LANGUAGE_EN } from '@home/_config/config';

import type { IUserFilterScopeChart, IUserFilterConfig } from '@dbl/core/dashboard';

interface IUserFilterSectionProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  showScope: boolean;
  onShowScopeChange: (show: boolean) => void;
  userFilter: IUserFilterConfig;
  chartList: IUserFilterScopeChart[];
  selectedChartIds: string[];
  onSelectedChartIdsChange: (ids: string[]) => void;
}

const UserFilterSection: React.FC<IUserFilterSectionProps> = (props) => {
  const {
    open,
    onOpenChange,
    showScope,
    onShowScopeChange,
    userFilter,
    chartList,
    selectedChartIds,
    onSelectedChartIdsChange,
  } = props;

  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  const hasUserFilterSection = Boolean(
    (userFilter?.controls?.length || 0) > 0 || (chartList || []).length > 0,
  );

  if (!hasUserFilterSection) {
    return null;
  }

  const title = (
    <div className="dbl-filter-setUp-title">
      {formatMessage({ id: 'dbl_filter_user_filter' })}
      <TipContext
        className="dbl-filter-setUp-title-icon"
        tipText={formatMessage({ id: 'dbl_create_dashboard_user_filter_info' })}
      />
    </div>
  );

  const scopeSettingLabel = (
    <div className="dbl-filter-setUp-title">
      {formatMessage({ id: 'dbl_create_dashboard_scope_setting' })}
      <TipContext
        className="dbl-filter-setUp-title-icon"
        tipText={formatMessage({
          id: 'dbl_create_dashboard_user_filter_scope_setting_info',
        })}
      />
    </div>
  );

  return (
    <SwitchCollapse title={title} defaultOpen={open} onOpenChange={onOpenChange}>
      <DatalabGrid colCount={2} gap={20}>
        <LabelText preset="838697-14-400">
          {formatMessage({ id: 'dbl_create_dashboard_scope_show' })}
        </LabelText>
        <Switch value={showScope} onChange={onShowScopeChange} />
        <DatalabGrid.Item verticalAlign="start">
          <LabelText preset="838697-14-400">{scopeSettingLabel}</LabelText>
        </DatalabGrid.Item>
        <Checkbox.Group
          value={selectedChartIds}
          className="dbl-filter-setUp__checkbox"
          onChange={onSelectedChartIdsChange}
        >
          {(chartList || []).map((item) => (
            <Checkbox key={item.task_id} name={String(item.task_id)}>
              {getLocalText(isEn, item.name_cn, item.name)}
            </Checkbox>
          ))}
        </Checkbox.Group>
      </DatalabGrid>
    </SwitchCollapse>
  );
};

export default UserFilterSection;

